import React from 'react';
import greenUpArrow from '../../images/dashboard/green up.png';
import redDownArrow from '../../images/dashboard/red down.png';
import './applicationCard.scss'

/**
 * ApplicationCard Component
 *
 * @component
  * @memberof Components
 * @param {Object} props - Component properties
 * @param {string} props.applicationType - The type of application ('services' or 'losses')
 * @param {string} props.applicationNameA - The first part of the application name
 * @param {string} props.applicationNameB - The second part of the application name
 * @param {number|string} props.pendingApplications - Number of pending applications
 * @param {number|string} props.totalApplications - Total number of applications
 * @param {string} props.descriptiveText - Descriptive text for the applications
 * @param {number} props.percentage - Percentage value (used for losses)
 * @param {string} [props.titleFontSize] - Optional font size for the title
 * @param {string} [props.figureFontSize] - Optional font size for the percentage figure
 *
 * @returns {JSX.Element} The rendered ApplicationCard component
 */
const ApplicationCard = (props) => {
    /**
     * Formats a number with commas as thousands separators.
     * @param {number|string} number - The number to format
     * @returns {string} The formatted number as a string
     */
    const numberFormatting = (number) => {
        if (number) {
            let intNumber = number
            if (typeof number === 'string') {
                intNumber = parseInt(number)
            }
            let formattedNumber = intNumber.toLocaleString(
                undefined,
                {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                }
            )
            return formattedNumber
        }
    };

    if (props.applicationType === "services") {
        return (
            <div className='application-box'>
                <p className='application-title'>{props.applicationNameA} <br /> {props.applicationNameB}</p>
                <div className='stats-container' style={{ flexDirection: 'column', alignItems: 'left' }}>
                    <h2 className='highlighted-counter'>{numberFormatting(props.pendingApplications)} {!numberFormatting(props.pendingApplications) && '_'}</h2>
                    <p className='descriptive-counter'>
                        {props.descriptiveText}
                    </p>
                    <span style={{ color: '#006ad1', fontSize: '0.95rem' }}>
                        {numberFormatting(props.totalApplications)} {!numberFormatting(props.totalApplications) && '_'}
                    </span>
                </div>
            </div >
        )
    }
    else if (props.applicationType === "losses") {
        return (
            <div className='application-box'>
                <p className='application-title' style={{ fontSize: props.titleFontSize }}>{props.applicationNameA} <br /> {props.applicationNameB}</p>
                <div className='stats-container' style={{ flexDirection: 'row', alignItems: 'center' }}>
                    <img src={
                        (props.applicationNameA === 'Recovery') ?
                            props.percentage > 0 ? greenUpArrow : redDownArrow :
                            (props.applicationNameA === 'T & D' || props.applicationNameA === 'AT & C') ?
                                props.percentage > 0 ? redDownArrow : greenUpArrow : ''
                    } alt="arrow Icon" className='icon'
                        style={{ rotate: (props.applicationNameA === 'T & D' || props.applicationNameA === 'AT & C') ? '180deg' : '' }}
                    />
                    <h2 className='percentage-content' style={{ fontSize: props.figureFontSize ? props.figureFontSize : '1.2vw' }}>{!isNaN(parseFloat(props.percentage)) ? Math.abs(parseFloat(props.percentage)) : '_'}%</h2>
                </div>
            </div>
        )
    }

}

export default ApplicationCard
